
<div v-if="visible" class="table-slash-picker" @keydown.esc="close">
  <div class="backdrop" @click="close" />
  <div
    ref="panel"
    class="panel"
    role="dialog"
    aria-modal="true"
    tabindex="-1"
    :aria-label="$t(resizing ? 'table.sizePickerResizeTitle' : 'table.sizePickerTitle')"
    @keydown.tab="trapTab"
  >
    <p class="title">{{ $t(resizing ? 'table.sizePickerResizeTitle' : 'table.sizePickerTitle') }}</p>
    <p class="size-label">{{ displayRows }} × {{ displayColumns }}</p>
    <div class="grid" :style="gridStyle" @mouseleave="resetHover" @keydown="onGridKeydown">
      <button
        v-for="cell in gridCells"
        :key="cell.key"
        type="button"
        class="cell"
        :data-cell="cell.key"
        :class="{ active: cell.row <= hoverRows && cell.col <= hoverColumns }"
        :tabindex="cell.row === hoverRows && cell.col === hoverColumns ? 0 : -1"
        :aria-label="cell.label"
        @mouseenter="setHover(cell.row, cell.col)"
        @focus="setHover(cell.row, cell.col)"
        @click="confirmAt(cell.row, cell.col)"
      />
    </div>
    <div class="actions">
      <n-button v-if="!resizing" size="s" :label="$t('table.sizePickerDefault')" @click="confirmDefault" />
      <n-button size="s" :label="$t('general.cancel')" @click="close" />
    </div>
  </div>
</div>
